import * as fixrecord from '../actions/fixRecordAction'

const initialState = {
    result: [],
    error: undefined,
    status: 0
};

const FixRecord = (state = initialState, action) => {
    switch (action.type) {
        case fixrecord.FIXRECORD_LIST_REQUEST:
            return ({
                ...initialState,
                status: 1
            });

        case fixrecord.FIXRECORD_LIST_SUCCESS:
            return ({
                ...action.result,
                error: undefined,
                status: 2
            });

        case fixrecord.FIXRECORD_LIST_FAILURE:
            return ({
                ...initialState,
                error: action.error,
                status: 3
            });

        case fixrecord.FIXRECORD_ADD_REQUEST:
            return ({
                ...state,
                status: 1
            });

        case fixrecord.FIXRECORD_ADD_SUCCESS:
            return ({
                ...action.result,
                error: undefined,
                status: 2
            });

        case fixrecord.FIXRECORD_ADD_FAILURE:
            return ({
                ...state,
                error: action.error,
                status: 3
            });

        case fixrecord.FIXRECORD_DELETE_REQUEST:
            return ({
                ...state,
                status: 1
            });

        case fixrecord.FIXRECORD_DELETE_SUCCESS:
            return ({
                ...action.result,
                error: undefined,
                status: 2
            });

        case fixrecord.FIXRECORD_DELETE_FAILURE:
            return ({
                ...state,
                error: action.error,
                status: 3
            });
            
        default:
            return (state);
    };
}

export default FixRecord;
